import { EventType } from "@/types";

import { axios } from "../axios.instance";

export type CancelEventRequest = {
  eventId: EventType["id"];
  cancellationReason: string;
};

export type CancelEventResponse = unknown;

export const cancelEvent = async (body: CancelEventRequest): Promise<CancelEventResponse> => {
  const { data } = await axios.post(`/events/manage/${body.eventId}/cancel`, {
    cancellationReason: body.cancellationReason,
  });

  return data;
};
